import { mapGetters, mapActions } from 'vuex'
import { currencyUtil, saleUtil, commonUtil } from '@/util'

import {
  ExpansionPanel,
  TotalAmountRefund,
  ProductTable,
  QuantityRackNumber
} from '@/components/items'

import ClientSearch from '@/components/layouts/ClientSearchArea/ClientSearchAreaRefund'
import ClientInfo from '@/components/layouts/ClientInfo/Refund/ClientInfo'
import ProductSearch from '@/components/layouts/ProductSearchArea/ProductSearchAreaSale'
import ProductInfo from '@/components/layouts/ProductInfo/Sales/ProductInfo'

import RegisterDialog from '@/components/layouts/Dialogs/MultipleArea/RefundInfoDialog/RefundRegisterDialog'
import CustomerInfo from '@/components/layouts/ClientConfirmation/CustomerInfo/CustomerInfoBase'
import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'
import headers from '@/views/sales/History/headers'
import headersShip from '@/views/sales/Ship/headers'
import headersRefund from '@/views/sales/RefundHistory/headers.js'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'
import PaymentTable from '@/components/items/Tables/PaymentTable'
import { BigNumber } from 'bignumber.js'
import { SelectCurrency } from '@/components/items/Selectboxes'

export default {
  name: 'RefundRegister',

  components: {
    ExpansionPanel,

    ClientSearch,
    ClientInfo,
    ProductSearch,
    ProductInfo,

    TotalAmountRefund,
    RegisterDialog,
    ProductTable,
    PaymentTable,
    QuantityRackNumber,
    HistoryList,
    CustomerInfo,

    DialogAlertError,

    SelectCurrency
  },
  data: () => {
    return {
      pageTitle: 'refund.refund_refund-register',
      controlNo: '',
      saleDetail: [],
      refundDetail: {},
      productInputData: [],
      rackNoSuggest: [],

      countryList: [],
      shipHistoryList: [],

      headers: {
        saleDetail: headers.productListHeaders,
        shipHeaders: [
          {
            text: 'ship.ship_ship-date',
            value: 'shipDate',
            width: '100px'
          },
          {
            text: 'ship.ship_ship-storage',
            value: 'storage.name',
            width: '90px'
          },
          {
            text: 'ship.ship_ship-user',
            value: 'userId',
            width: '90px'
          }
        ],
        shipProductHeaders: headersShip.productListHeaders
      },

      pageData: {
        refund: {
          name: 'loadingInfo',
          productHeaders: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '87px',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '175px'
            },
            {
              text: 'common.product_consumption-tax-rate',
              value: 'product.taxId',
              sortable: false,
              width: '56px',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center',
              unit: '%'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '56px',
              align: 'center'
            },
            {
              text: 'sale.sale_number-of-sales',
              value: 'quantity',
              sortable: false,
              width: '56px',
              align: 'center'
            },
            {
              text: 'ship.ship_already-ship',
              value: 'done',
              sortable: false,
              width: '56px',
              align: 'center'
            },
            {
              text: 'sale.sale_sale-price',
              value: 'price',
              sortable: false,
              width: '82px',
              align: 'end'
            },
            {
              text: 'sale.sale_sale-amount',
              value: 'saleAmount',
              sortable: false,
              width: '85px',
              align: 'end'
            },
            {
              text: 'refund.refund_refund-quantity-rack',
              value: 'quantityAndStorageNo',
              input: true,
              sortable: false,
              width: '210px',
              align: 'center'
            },
            {
              text: 'refund.refund_refund-purchase-currency',
              value: 'productCurrency',
              sortable: false,
              width: '80px',
              align: 'center'
            },
            {
              text: 'refund.refund_refund-purchase-unit-price-total-amount',
              value: 'refundPurchasePrice', // 返金時仕入れ単価
              sortable: false,
              width: '75px',
              align: 'center'
            },
            {
              text: 'refund.refund_refund-unit-price-total-amount',
              value: 'refundPrice', // 返金単価
              sortable: false,
              width: '89px',
              align: 'center'
            },
            {
              text: 'sale.sale_exporter',
              value: 'exportSubjectFlg',
              sortable: false,
              width: '66px',
              align: 'center'
            }
          ],
          itemKey: 'product.productId',
          items: null
        }
      },
      paymentData: {},
      refundHistoryData: {
        historyList: [],
        summary: {},
        headers: [],
        tableKey: ''
      },

      pageType: {
        en: 'sale',
        ja: '注文'
      },

      dialog: {
        dialog: false
      },

      registerData: {
        client: {},
        totalList: {
          taxFree: 0,
          tax10: {
            totalAmount: 0,
            tax: 0
          },
          tax8: {
            totalAmount: 0,
            tax: 0
          },
          adjust: 0,
          totalAmount: 0,

          unitName: ''
        }
      },

      clientAreaInfo: {
        isOpen: false,
        isSelect: false,
        selectInfo: {}
      },
      selectCurrency: { currencyId: null, name: '', unitName: '' },
      history: {
        productMoves: []
      },

      productSearchInfo: {
        keyword: '',
        category: ''
      },

      errMessage: '',
      errDialog: false
    }
  },
  async created() {
    this.setCurrency(this.getCurrencyJpFromState().value)
    this.countryList = this.getCountryCallingCodeListFromState()
  },
  methods: {
    ...mapActions('Sale', [
      'getSaleDetailFromApi',
      'getRackNumberByProductFromApi'
    ]),
    ...mapActions('Ship', ['getShipListFromApi']),
    ...mapActions('Refund', ['getRefundListFromApi']),

    ...mapActions('Common', ['setIsLoading']),
    ...mapGetters('Common', [
      'getCurrencyJpFromState',
      'getCountryCallingCodeListFromState'
    ]),
    ...mapGetters('Sale', ['getRackNumberByPaymentFromState']),
    ...mapGetters('Refund', ['getRefundListFromState']),

    opnePanel(...args) {
      const [index] = args
      this.clientAreaInfo.isOpen = index.length > 0
    },
    getAmount() {
      // 合計金額
      return saleUtil.calcSaleAmount(this.saleDetail[0].sale)
    },
    getPayAmount(paymentList) {
      // 入金済金額
      return paymentList.reduce((sum, ele) => {
        return sum + Number(ele.amount)
      }, 0)
    },

    async changeControlNo(controlNo) {
      this.setIsLoading(true)
      this.controlNo = controlNo
      if (controlNo.length === 0) {
        this.setIsLoading(false)
        return
      }
      const ret = await this.getSaleDetailFromApi({
        saleControlNumber: controlNo
      })
      // 検索項目は履歴に対して一意なので、[0]決め打ち
      // retがundefinedの場合、返却値を空にする
      this.saleDetail = ret ? ret.data : []
      if (this.saleDetail.length > 0 && !this.saleDetail[0].sale.compDate) {
        alert(this.$t('sale.sale_not-sale-comp'))
      } else if (
        this.saleDetail.length > 0 &&
        this.saleDetail[0].sale.compDate
      ) {
        // 出庫済み数の計算
        // 1. まず、商品IDごとの出庫合計数を計算
        const totalShippedByProduct = {}
        // 全出庫履歴をループ
        this.saleDetail[0].shippedList.forEach((shipment) => {
          // 各出庫履歴内の商品をループ
          shipment.productMoves.forEach((shippedMove) => {
            const productId = shippedMove.product.productId
            if (!totalShippedByProduct[productId]) {
              totalShippedByProduct[productId] = 0
            }
            totalShippedByProduct[productId] += shippedMove.quantity
          })
        })

        // 2. 次に、販売明細をループして、計算した出庫合計数を順に割り当て
        this.saleDetail[0].sale.productMoves.forEach((saleMove) => {
          const productId = saleMove.product.productId
          const remainingShipped = totalShippedByProduct[productId] || 0

          // この明細行に割り当てられる出庫数を計算 (残出庫数と注文数のうち少ない方)
          const shippedForThisLine = Math.min(
            remainingShipped,
            saleMove.quantity
          )

          // 計算結果を `shippedQuantity` という新しいプロパティとして明細データに追加
          saleMove.shippedQuantity = shippedForThisLine

          // 次の明細のために、残りの出庫数を更新
          if (totalShippedByProduct[productId]) {
            totalShippedByProduct[productId] -= shippedForThisLine
          }
        })

        this.productInputData = this.saleDetail[0].sale.productMoves.map(
          (ele) => {
            const ret = {
              productMoveId: ele.productMoveId,
              productId: ele.product.productId,
              rackInfoList: [],
              price: ele.product.purchasePrice,
              currency: currencyUtil.getCurrencyIdInfo(
                ele.product.purchasePriceCurrencyId
              ),
              refundPrice: ele.price,
              refundCurrencyId: ele.currencyId,
              exportSubjectFlg: ele.exportSubjectFlg
            }
            return ret
          }
        )
        this.registerData.totalList.unitName =
          currencyUtil.findCurrencyNameById(
            this.saleDetail[0].sale.currencyId
          ).unitName
        this.clientAreaInfo.isOpen = true

        // 出庫履歴
        this.shipHistoryList = await this.getShipList()
        // 入金履歴
        const amount = this.getAmount()
        const payAmount = this.getPayAmount(this.saleDetail[0].paidList)
        const notPayAmount = amount - payAmount

        this.paymentData = {
          title: 'payment.payment_sale-payment-history',
          name: 'paymentHistory',
          buttonName: 'payment.payment_sale-payment-cancel',
          itemKey: 'salePaymentId',
          headers: [
            {
              text: 'payment.payment_sale-payment-date',
              value: 'date',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_sale-payment-price',
              value: 'amount',
              sortable: false,
              width: '12%',
              align: 'end'
            },
            {
              text: 'payment.payment_sale-payment-method',
              value: 'paymentMethodId',
              sortable: false,
              width: '12%'
            },
            { text: '', sortable: false }
          ],
          items: this.saleDetail[0].paidList,
          footers: [
            {
              name: 'payment.payment_already-sale-payment-price',
              data: payAmount
            },
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'payment.payment_unpaid-price',
              data: notPayAmount
            }
          ]
        }
        // 返金履歴
        const refundHistoryList = await this.getRefundListFromApi({
          invalidRefundDisplay: 0,
          saleControlNumber: this.controlNo
        })
        const isNoData = !Object.keys(refundHistoryList.data).length
        this.refundHistoryData = {
          historyList: isNoData
            ? []
            : refundHistoryList.data
                .sort((a, b) => {
                  const keyName = 'refundId'
                  if (a[keyName] < b[keyName]) return 1
                  if (a[keyName] > b[keyName]) return -1
                  return 0
                })
                .map((ele, Index) => {
                  ele.panelIndex = Index + 1
                  // ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
                  return ele
                }),
          headers: headersRefund.headers,
          productListHeaders: headersRefund.productListHeaders,

          tableKey: headersRefund.tableKey
        }
        // 消費税の初期値入力
        this.registerData.totalList.tax8.tax =
          this.saleDetail[0].sale.consumptionTax8
        this.registerData.totalList.tax10.tax =
          this.saleDetail[0].sale.consumptionTax10
      }
      this.setIsLoading(false)
    },
    async getShipList() {
      const shipList = await this.getShipListFromApi({
        invalidShipDisplay: 0,
        saleControlNumber: this.controlNo
      })
      const format = shipList.data
        .sort((a, b) => {
          const keyName = 'shipId'
          if (a[keyName] < b[keyName]) return 1
          if (a[keyName] > b[keyName]) return -1
          return 0
        })
        .map((ele, Index) => {
          ele.panelIndex = Index + 1
          return ele
        })
      return format
    },
    async changeRefundMetaData(data) {
      this.refundDetail = data
      this.refundDetail.saleId = this.saleDetail[0].sale.saleId
      this.refundDetail.currencyId = this.saleDetail[0].sale.currencyId
      this.refundDetail.controlNo = this.controlNo
      await this.setRackNoSuggest()
    },
    async getProductListForRackNumber() {
      const productIdList = [
        ...new Set(
          this.saleDetail[0].sale.productMoves.map(
            (ele) => ele.product.productId
          )
        )
      ]

      if (this.refundDetail.storage.value) {
        await this.getRackNumberByProductFromApi({
          storageId: this.refundDetail.storage.value,
          productIdList: productIdList
        })
      }

      const productListForRackNumber = this.getRackNumberByPaymentFromState()
      return productListForRackNumber
    },
    async getRackNumber() {
      const productListForRackNumber = await this.getProductListForRackNumber()
      const allRackNumberList = productListForRackNumber.map((ele) => {
        return {
          productId: ele.productId,
          rackInfoList: ele.rackInfoList
        }
      })
      return allRackNumberList
    },
    getNote(type) {
      const target = this.saleDetail[0].sale.saleNote.find(
        (ele) => ele.type === type
      )
      return target ? target.body : ''
    },
    getRackNumberList(allRackNumberList, productId) {
      // 対象商品が管理されている棚番号一覧
      const rackInfoList = allRackNumberList
        .filter((ele) => ele.rackInfoList.length > 0)
        .map((ele) => {
          ele.rackInfoList = ele.rackInfoList.filter((ele) => ele.rackNumber)
          return ele
        })
        .find((v) => {
          return v.productId === productId
        })
        ?.rackInfoList.map((rackInfo) => {
          return rackInfo.rackNumber
        })

      return rackInfoList ? rackInfoList : []
    },
    async setRackNoSuggest() {
      const allRackNumberList = await this.getRackNumber()

      this.rackNoSuggest = this.saleDetail[0].sale.productMoves.map((ele) => {
        return {
          productMoveId: ele.productMoveId,
          productId: ele.product.productId,
          rackNumberList: this.getRackNumberList(
            allRackNumberList,
            ele.product.productId
          )
        }
      })
    },
    setCurrency(currencyId) {
      const currency = currencyUtil.findCurrencyNameById(currencyId)
      const selectCurrency = currency
        ? currency
        : { currencyId: null, name: '', unitName: '' }

      this.selectCurrency = selectCurrency
      this.registerData.totalList.unitName = selectCurrency.unitName
    },

    inputKeyword(...args) {
      const [keyword] = args
      this.productSearchInfo.keyword = keyword
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.productSearchInfo.category = categoryId
    },

    changeProductInfo(...args) {
      const [isHistory, productInfo] = args

      const clientInfo = this.clientAreaInfo.selectInfo

      const totalList = this.registerData.totalList
      if (isHistory) {
        totalList.tax10.tax = clientInfo.consumptionTax10
        totalList.tax8.tax = clientInfo.consumptionTax8
        totalList.discount = clientInfo.discount
        totalList.shipping = clientInfo.comission
      }
      // totalList.tax10.tax = isHistory ? clientInfo.consumptionTax10 : 0
      // totalList.tax8.tax = isHistory ? clientInfo.consumptionTax8 : 0
      // totalList.discount = isHistory ? clientInfo.discount : 0
      // totalList.shipping = isHistory ? clientInfo.comission : 0

      this.registerData.product = {
        isHistory: isHistory,
        data: productInfo
          .filter((ele) => ele.amount > 0)
          .map((ele) => {
            ele.currencyId = this.selectCurrency.currencyId
            return ele
          })
      }
    },
    updateRegisterDataProductCurrencyId() {
      const productData = this.registerData.product.data
      if (!productData.length) return

      this.registerData.product.data = productData.map((ele) => {
        ele.currencyId = this.selectCurrency.currencyId
        return ele
      })
    },
    // 出庫済み（changeControlNoメソッドで計算するため削除）

    // 返金済み
    getRefundedQuantity(productId) {
      const quantity = this.saleDetail[0].refundedList
        .filter((refund) => refund.status !== 99)
        .reduce((res, cur) => {
          const productMove = cur.productMoves.find((ele) => {
            return ele.product.productId == productId
          })
          if (productMove) res += productMove.quantity
          return res
        }, 0)
      return quantity
    },
    getNotRefundedQuantity(productMoveId) {
      // findの検索条件をproductIdから、一意なproductMoveIdに変更
      const saleProductMove = this.saleDetail[0].sale.productMoves.find(
        (ele) => ele.productMoveId === productMoveId
      )
      // 念のため、該当の明細が見つからない場合は0を返す
      if (!saleProductMove) {
        return 0
      }
      // 返金済数量の計算にはproductIdが必要なため、見つけた明細からproductIdを取得
      const productId = saleProductMove.product.productId
      return saleProductMove.quantity - this.getRefundedQuantity(productId)
    },
    getDispAmountPrice(item) {
      const amount = item.price * item.quantity
      return (
        commonUtil.formatPrice(amount).toLocaleString() + this.getUnit(item)
      )
    },
    getUnit(item) {
      return currencyUtil.findCurrencyNameById(item.currencyId).unitName
    },
    getProductInputDataIndex(productMoveId) {
      return this.productInputData.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },
    onChangeQuantityRackNumber(productMoveId, event) {
      const rackInfoList = event
      this.updateProductData(productMoveId, 'rackInfoList', rackInfoList)
    },
    updateProductData(productMoveId, updatePropertyNameName, updateData) {
      this.productInputData = this.productInputData.map((ele) => {
        if (ele.productMoveId === productMoveId) {
          ele[updatePropertyNameName] = updateData
        }
        return ele
      })
    },
    calcRefundPurchaseAmount(productMoveId) {
      const inputData =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      const quantity = inputData.rackInfoList.reduce((res, cur) => {
        return (res += Number(cur.quantity))
      }, 0)

      return commonUtil
        .formatPrice(BigNumber(inputData.price).times(quantity).toNumber())
        .toLocaleString()
    },
    calcAmount(productMoveId) {
      const inputData =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      const quantity = inputData.rackInfoList.reduce((res, cur) => {
        return (res += Number(cur.quantity))
      }, 0)

      return BigNumber(inputData.refundPrice)
        .times(quantity * -1)
        .toNumber()
    },
    calcAmountDisplay(productMoveId) {
      const inputData =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      const quantity = inputData.rackInfoList.reduce((res, cur) => {
        return (res += Number(cur.quantity))
      }, 0)

      return (
        commonUtil
          .formatPrice(
            BigNumber(inputData.refundPrice)
              .times(quantity * -1)
              .toNumber()
          )
          .toLocaleString() +
        currencyUtil.findCurrencyNameById(inputData.refundCurrencyId).unitName
      )
    },

    register() {
      this.dialog.dialog = true
    },
    rowDialogMethodCommon() {
      return
    }
  },
  watch: {
    productInputData: {
      deep: true,
      handler(newVal, oldVal) {
        let taxFree = 0
        let tax10 = 0
        let tax8 = 0
        newVal.reduce((res, cur) => {
          if (cur.exportSubjectFlg) {
            taxFree += this.calcAmount(cur.productMoveId)
          } else {
            const target = this.saleDetail[0].sale.productMoves.find((ele) => {
              return ele.productMoveId === cur.productMoveId
            })
            if (target.product.taxId === 1) {
              tax8 += this.calcAmount(cur.productMoveId)
            } else if (target.product.taxId === 2) {
              tax10 += this.calcAmount(cur.productMoveId)
            }
          }
          return
        }, 0)
        this.registerData.totalList.taxFree = taxFree
        this.registerData.totalList.tax10.totalAmount = tax10
        this.registerData.totalList.tax8.totalAmount = tax8
      }
    }
  }
}
